import { format, isSameDay, isToday, isYesterday, differenceInCalendarDays } from 'date-fns'
import { enGB, nl } from 'date-fns/locale'

const localeFor = (locale: string) => (locale === 'nl' ? nl : enGB)

/** Time today, weekday this week, date before that: what a chat list shows. */
export function listTime(iso: string, locale: string): string {
  const date = new Date(iso)
  if (isToday(date)) return format(date, 'HH:mm')
  if (differenceInCalendarDays(new Date(), date) < 7) {
    return format(date, 'EEE', { locale: localeFor(locale) })
  }
  return format(date, 'd MMM', { locale: localeFor(locale) })
}

export function messageTime(iso: string): string {
  return format(new Date(iso), 'HH:mm')
}

export function dayLabel(iso: string, locale: string): string {
  const date = new Date(iso)
  if (isToday(date)) return locale === 'nl' ? 'Vandaag' : 'Today'
  if (isYesterday(date)) return locale === 'nl' ? 'Gisteren' : 'Yesterday'
  return format(date, 'EEEE d MMMM', { locale: localeFor(locale) })
}

export function sameDay(a: string, b: string): boolean {
  return isSameDay(new Date(a), new Date(b))
}

export function fileSize(bytes: number): string {
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`
}

export function personName(p: { first_name: string | null; last_name: string | null }): string {
  return [p.first_name, p.last_name].filter(Boolean).join(' ') || '—'
}
